module.exports = __webpack_public_path__ + "img/forgiveness-main-pic.65d380fb.png";